import { BaseApi } from './base.api.js';

export class LessonLearnedApi extends BaseApi {
    constructor(client, basePath = '/lesson-learned') {
        super(client, basePath);
    }
}
